/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlNatureQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceControlNatureQueryOperator");
    }

    getFixupPrototypeFunction() { return ComplianceControlNatureQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlNatureQueryOperator>): ComplianceControlNatureQueryOperator {
        let obj = Object.assign(new ComplianceControlNatureQueryOperator(), model);
        ComplianceControlNatureQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlNatureQueryOperator>): ComplianceControlNatureQueryOperator {
        if (!model) return null;
        return ComplianceControlNatureQueryOperator.newInstance(<ComplianceControlNatureQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlNatureQueryOperator) {
        if (!obj) return;

        models.ComplianceControlNatureQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlNatureQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceControlNatureQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Control natures to include
     */
    natures: Array<models.ControlNature>;

}
